import 'react-app-polyfill/ie9';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/store';
import logger from './app/logger.js';
import App from './app/app';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

const welcome = () => logger.info('Welcome to Mission Control 🕹');
welcome('de529c70-eb80-4dfb-9540-5075db7545bf')